export function Separator({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="2"
      viewBox="0 0 1000 2"
      preserveAspectRatio="none"
      fill="none"
      className={className}
      aria-label="separator"
    >
      <title>Separator</title>
      <path
        d="M0 1H1000"
        stroke="var(--color-viken-rock-200)"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  )
}
